<template>
  <div class="login-container">
    <div class="login-box bg-white radius-20 w-520 h-520">
      <div class="text-center padding-top-40 padding-bottom-30 text-bold text-main text-32">登录</div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form w-450" label-width="0">
        <el-form-item prop="account">
          <el-input v-model="loginForm.account" placeholder="手机号/邮箱" size="large" class="custom-input"
            @keyup.enter.native="handleLogin">
            <template slot="prefix">
              <img :src="icon1" alt="icon" class="input-icon" />
            </template>
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" size="large" show-password
            class="custom-input" @keyup.enter.native="handleLogin">
            <template slot="prefix">
              <img :src="icon1" alt="icon" class="input-icon" />
            </template>
          </el-input>
        </el-form-item>
        <div class="text-777-color text-right padding-bottom-37">
          <span @click="goToForgotPassword">忘记密码？</span>
        </div>
        <el-button type="primary" size="large" :loading="loading" class="login-button radius-100 bg-main"
          @click="handleLogin">
          {{ loading ? '登录中...' : '登录' }}
        </el-button>
        <div class="text-center text-main text-weight-500 padding-top-20">
          <span @click="goToRegister">没有账号去注册</span>
        </div>
        <div class="text-11 text-center padding-top-30">
          <el-checkbox v-model="checked"> </el-checkbox>
          我已阅读并同意<span class="text-main cursor-pointer" @click="showTextDialog(3)">《用户协议》</span>和<span
            class="text-main cursor-pointer" @click="showTextDialog(4)">《隐私政策》</span>
        </div>
      </el-form>
    </div>

    <!-- 文本信息弹窗 -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="800px" :close-on-click-modal="false"
      class="text-dialog">
      <div v-loading="textLoading" class="text-content">
        <div v-html="dialogContent"></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { login, getText } from '@/api/user';

export default {
  name: 'Login',
  data() {
    // 自定义账号验证规则（手机号或邮箱）
    const validateAccount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号或邮箱'));
      } else {
        const phoneReg = /^1[3-9]\d{9}$/;
        const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!phoneReg.test(value) && !emailReg.test(value)) {
          callback(new Error('请输入正确的手机号或邮箱格式'));
        } else {
          callback();
        }
      }
    };

    // 自定义密码验证规则
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码长度不能少于6个字符'));
      } else {
        callback();
      }
    };

    return {
      checked: false,
      icon1: require('@/assets/images/icon1.png'),
      loginForm: {
        account: '',//admin//17601256604
        password: ''//123456//123456
      },
      // loginRules: {
      //   account: [
      //     { validator: validateAccount, trigger: 'blur' }
      //   ],
      //   password: [
      //     { validator: validatePassword, trigger: 'blur' }
      //   ]
      // },
      rememberMe: false,
      loading: false,
      // 弹窗相关
      dialogVisible: false,
      dialogTitle: '',
      dialogContent: '',
      textLoading: false
    };
  },
  mounted() {
    // 如果之前选择了记住我，从本地存储恢复账号
    const savedAccount = localStorage.getItem('savedAccount');
    if (savedAccount) {
      this.loginForm.account = savedAccount;
      this.rememberMe = true;
    }
  },
  methods: {
    goToForgotPassword() {
      this.$router.push('/forgot-password');
    },
    goToRegister() {
      this.$router.push('/register');
    },
    // 显示文本信息弹窗
    showTextDialog(type) {
      // type: 1=关于我们, 2=邮箱授权, 3=用户协议, 4=隐私政策
      const typeMap = {
        1: '关于我们',
        2: '邮箱授权',
        3: '用户协议',
        4: '隐私政策'
      };

      this.dialogTitle = typeMap[type] || '文本信息';
      this.dialogVisible = true;
      this.dialogContent = '';
      this.textLoading = true;

      // 调用接口获取文本内容
      getText(type.toString())
        .then(response => {
          this.textLoading = false;
          if (response.data) {
            this.dialogContent = response.data[0].content;
          } else {
            this.dialogContent = '暂无内容';
          }
        });
    },
    handleLogin() {
      if (!this.checked) return this.$message.error('请先阅读并同意协议！');
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          // 调用登录接口
          login({
            account: this.loginForm.account,
            password: this.loginForm.password
          })
            .then(response => {
              this.loading = false;

              // 如果选择记住我，保存账号
              if (this.rememberMe) {
                localStorage.setItem('savedAccount', this.loginForm.account);
              } else {
                localStorage.removeItem('savedAccount');
              }

              // 先清空上一账号的登录数据，避免与当前账号混用导致个人中心显示错乱
              localStorage.removeItem("token");
              localStorage.removeItem("userInfo");
              localStorage.removeItem("userId");
              localStorage.removeItem("userName");
              localStorage.removeItem("userAvatar");
              localStorage.removeItem("isLoggedIn");

              // 保存登录状态和用户信息
              localStorage.setItem('isLoggedIn', 'true');

              // 保存用户信息（根据接口返回的数据结构调整）
              if (response.data) {
                const userInfo = response.data;
                // 优先使用顶层的 nickname，如果没有则使用 userinfo.nickname
                const nickname = userInfo.nickname || (userInfo.userinfo && userInfo.userinfo.nickname) || userInfo.username || '用户';
                localStorage.setItem('userName', nickname);

                // 保存头像（优先使用顶层，其次 userinfo）
                const avatar = userInfo.avatar || (userInfo.userinfo && userInfo.userinfo.avatar);
                if (avatar) {
                  localStorage.setItem('userAvatar', avatar);
                }

                // 保存用户ID和token
                if (userInfo.id || userInfo.user_id) {
                  localStorage.setItem('userId', userInfo.id || userInfo.user_id);
                }
                if (userInfo.token) {
                  localStorage.setItem('token', userInfo.token);
                }

                // 保存完整的用户信息（JSON格式）
                localStorage.setItem('userInfo', JSON.stringify(userInfo));
              } else {
                // 如果没有返回用户信息，使用账号作为默认用户名
                localStorage.setItem('userName', this.loginForm.account);
              }

              // 登录成功后的处理
              this.$message.success('登录成功！');

              // 登录成功后跳转到首页
              this.$router.push('/');
            })
            .catch(error => {
              this.loading = false;
              this.$message.error(error.message || '登录失败，请稍后重试');
            });
        } else {
          this.$message.error('请填写完整的登录信息');
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  background-image: url('@/assets/images/login.png');
  background-size: 100% 100%;
}

.login-box {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.5s ease-out;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


.login-form {
  margin: 0 auto;
}

.login-form .el-form-item {
  margin-bottom: 22px;
}

.custom-input {
  width: 450px;
  height: 62px;
}

.custom-input /deep/ .el-input__inner {
  width: 450px;
  height: 62px;
  line-height: 62px;
  padding-left: 55px;
}

.custom-input /deep/ .el-input__prefix {
  left: 20px;
}

.input-icon {
  width: 17px;
  height: 20px;
  margin-top: 21px;
}

.login-button {
  width: 450px;
  height: 61px;
  border: none;
}

.cursor-pointer {
  cursor: pointer;
}

.text-dialog ::v-deep .el-dialog__body {
  max-height: 600px;
  overflow-y: auto;
}

.text-content {
  min-height: 200px;
  line-height: 1.8;
  color: #333;
  word-wrap: break-word;
}

.text-content ::v-deep p {
  margin-bottom: 10px;
}

.text-content ::v-deep h1,
.text-content ::v-deep h2,
.text-content ::v-deep h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: bold;
}
</style>
